import { useMutation } from '@apollo/client';
import updateDashboardPageViewedMutation from '../graphql/mutations/updateDashboardPageViewed.graphql';

export default function useUpdateDashboardPageViewed(page) {
  return useMutation(updateDashboardPageViewedMutation, {
    variables: { page }
  });
}
